import type { PositionMessage } from "@/common/api/mqttClient";
import { useEventBus } from "@vueuse/core";

export function useNewPosition() {
  return useEventBus<PositionMessage>("new-position");
}
